import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import MoreVert from '@material-ui/icons/MoreVert';
import Menu from '@ublend-npm/aulaui-next-web/Menu';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';

import IconButton from '../../common/Buttons/IconButton';
import {
  container,
  content,
  focused as focusedClass,
  icon,
} from './ConversationFilter.styled';

const concatClassNames = (...classNames) =>
  classNames.filter((name) => !!name).join(' ');

const PLACEHOLDER = 'Search in messages';

const ConversationFilter = ({
  focused,
  onBlur,
  onChange,
  onFocus,
  value,
  getInputProps,
  handleCollapse,
}) => (
  <div className={container}>
    <div className={concatClassNames(content, focused && focusedClass)}>
      <SearchIcon className={icon} />
      <input
        aria-label={PLACEHOLDER}
        type="text"
        placeholder={PLACEHOLDER}
        {...getInputProps({
          onBlur,
          onFocus,
          onChange,
          value,
        })}
      />
    </div>
    <div>
      <Menu
        ariaLabelledby="inbox-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        renderTarget={({ handleTargetClick }) => (
          <IconButton
            label="More options"
            icon={MoreVert}
            size="small"
            onClick={handleTargetClick}
          />
        )}
        onSelect={handleCollapse}
        renderChildren={({ getItemProps }) => (
          <ListItem
            size="medium"
            primaryText="Hide messages panel"
            {...getItemProps({
              item: 'collapse-conversation',
              onClick: (e) => e.stopPropagation(),
            })}
          />
        )}
      />
    </div>
  </div>
);

ConversationFilter.propTypes = {
  focused: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  handleCollapse: PropTypes.func.isRequired,
};

export default ConversationFilter;
